import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-professional-services-landing-page',
  templateUrl: './professional-services-landing-page.component.html',
  styleUrls: ['./professional-services-landing-page.component.scss']
})
export class ProfessionalServicesLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
